import React, { useEffect } from 'react'
import serverData from '../../utils/server-data'
import DOMPurify from 'dompurify'

function CookiePrefsSettings() {
  useEffect(() => {
    const { js } = serverData.data
    if (js) {
      const cookieBannerJs = document.createElement('script')
      cookieBannerJs.setAttribute('id', 'bannerScript')
      cookieBannerJs.setAttribute(
        'nonce',
        document.querySelector('body').dataset.nonce,
      )
      cookieBannerJs.innerHTML = js.replace(/(<([^>]+)>)/gi, '')
      document.body.appendChild(cookieBannerJs)
    }
  }, [])
  return <div dangerouslySetInnerHTML={rawMarkup(serverData)} />
}
function rawMarkup(props) {
  if (props.data && props.data.css && props.data.html) {
    const sanitizedHTML = DOMPurify.sanitize(props.data.html)
    const rawMarkupHTML = props.data.css + sanitizedHTML

    return { __html: rawMarkupHTML }
  }
  return null
}

export default CookiePrefsSettings
